import { useState } from 'react'
import {
  SYSTEMS_BY_DEFAULT_NEW,
  SYSTEMS_BY_DEFAULT_ACTIVE,
  SYSTEMS_BY_DEFAULT_TURNOVERS
} from '../constants'

type OwnProps = {
  isNewTab: boolean
  availableSystems?: Record<string, string>
  minTotalTurnover?: number
}

const useDefaultSystems = ({ isNewTab, availableSystems, minTotalTurnover }: OwnProps) => {
  const [turnovers, setTurnovers] = useState<null | { [code: string]: number }>(null)
  const selectSystemsByDefault = () => {
    if (!availableSystems || !minTotalTurnover) {
      return
    }
    const defaultSystems: Array<string> = isNewTab
      ? SYSTEMS_BY_DEFAULT_NEW
      : SYSTEMS_BY_DEFAULT_ACTIVE

    setTurnovers(
      Object.fromEntries(
        defaultSystems
          .filter(code => {
            return code in availableSystems
          })
          .map(code => {
            return [code, SYSTEMS_BY_DEFAULT_TURNOVERS[code] || 30000]
          })
      )
    )
  }

  return {
    turnovers,
    setTurnovers,
    selectSystemsByDefault
  }
}

export default useDefaultSystems
